import { formatLastUpdatedDate } from '../../../utils/date-utils';
import { useGetHealthData } from '../../../use-health-data';

export function LastUpdatedTag() {
  const { healthData } = useGetHealthData();
  const lastUpdatedDate = healthData?.metadata?.lastUpdated;

  if (!lastUpdatedDate) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <div className="bg-white/10 rounded-full px-3 py-0.5">
        <span className="text-white text-xs font-bold">
          Last Updated {formatLastUpdatedDate(lastUpdatedDate)}
        </span>
      </div>
    </div>
  );
}
